export const ConversationStatusList = [
  {
    label: 'Needs attention',
    value: 'FOLLOWUP_NEEDED',
    className: 'needs_attention',
    iconclassName: 'priority_high',
  },
  {
    label: 'Resolved',
    value: 'HANDLED',
    className: 'mark_resolved',
    iconclassName: 'check',
  },
  {
    label: 'Set status',
    value: 'NONE',
    className: 'none',
  },
];
